var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isMemberFree())?_c('div',{staticClass:"member-free-tag"},[_vm._v("会员免费")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }